import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    //診断質問
    totalQuestion:52,
    sectionQuestion:10,
    //各設問のスコア設定
    plusMaxValue:3,
		plusMedValue:2,
		plusMinValue:1,
		neutralValue:0,
		minusMinValue:-1,
		minusMedValue:-2,
		minusMaxValue:-3,
    //【質問票01】内向度診断
    levelQuestions:[
      {	id: 1, title:'会議に出ることは、他の仕事よりも疲れが溜まると感じる',	score:null , reverse:false	},
      {	id: 2, title:'相手から至れり尽くせりな親切をされると、喜びと同時に罪悪感や申し訳なさを感じてしまう',	score:null, reverse:false	},
      {	id: 3, title:'自分は流行や皆が好むものよりもニッチでアングラなものを好む傾向がある',	score:null, reverse:false	},
      {	id: 4, title:'周りの人たちに比べて親友と呼べる人の数が割と多いように思う',	score:null, reverse:true	},
      {	id: 5, title:'何かあると、メールやチャットよりも、電話で相手と連絡を取る方が楽だ',	score:null, reverse:true	},
      {	id: 6, title:'データを解析したり、数字を追うことの方が、哲学的なことよりも大好きで自分らしさを感じられる',	score:null, reverse:true	},
      {	id: 7, title:'いい意味で鈍感だと思っている',	score:null, reverse:true	},
      {	id: 8, title:'体を使った野性的で開放的なスポーツや趣味のほうが、頭を使ったクリエイティブな作業よりも好きだ',	score:null, reverse:false	},
      {	id: 9, title:'あなたが電車でお年寄りに席を譲ろうとする際、勇気をまったく必要とせず、プレッシャーもほとんど感じることもない',	score:null, reverse:true	},
      {	id:10, title:'他人の気持ちを「察する」ことはできるが、深く「共感する」ことはできないと感じることがよくある',	score:null, reverse:false	},
      {	id:11, title:'相手からとっさに優しくされると「ありがとう」よりも「すみません！」と言ってしまいがちになる',	score:null, reverse:false	},
      {	id:12, title:'大人数でワイワイ過ごすパーティーよりも、1対1、少人数での会食、もしくは自分だけの一人飲みのほうがずっと好きだ',	score:null, reverse:false	},
    ],
    //【質問票02】自己犠牲マインド診断
    sacrificeMindQuestions:[
      {	id: 11, title:'自己犠牲をしてしまうことがよくある',	score:null , reverse:false	},
      {	id: 12, title:'自分が忙しいにも関わらず、相手に頼まれると断れないことが多い',	score:null, reverse:false	},
      {	id: 13, title:'自分のペースや好みと相手の事情を上手く合わせて楽しむことができる',	score:null, reverse:false	},
      {	id: 14, title:'サービス精神を出しすぎて頑張ってしまうことがある',	score:null, reverse:false	},
      {	id: 15, title:'自分のために使える時間が非常に少ないと感じてしまうことが多々ある',	score:null, reverse:false	},
      {	id: 16, title:'スケジュール通りに物事が運ぶことに大きな価値があると思う',	score:null, reverse:true	},
      {	id: 17, title:'自分が人に合わせるよりも、自分が人に合わせてもらうことのほうが多い',	score:null, reverse:true	},
      {	id: 18, title:'自分の良いと思ったモノを相手にプレゼントしたり、薦めたりするのが好きだ',	score:null, reverse:true	},
      {	id: 19, title:'譲ること、譲歩することはとてもカッコよくて誇らしいことだと思う',	score:null, reverse:false	},
      {	id: 20, title:'意思が強く、様々な物事において、プライベートでもマイルールが多いほうだ',	score:null, reverse:true	},  
    ],
    //【質問票03】自己投資マインド診断
    investMindQuestions:[
      {	id: 21, title:'日常的な楽しみや趣味にお金を使うより、仕事のスキルアップのための自己研磨にお金を使っている',	score:null , reverse:false	},
      {	id: 22, title:'貯金が好きで、使うことより使わないことを考えがちである',	score:null, reverse:true	},
      {	id: 23, title:'戦略的に借金したり、融資を請けたりして、何かにチャレンジするのはリスキーだと感じる',	score:null, reverse:true	},
      {	id: 24, title:'仕事や私生活はとても規則正しいほうだと思う',	score:null, reverse:false	},
      {	id: 25, title:'スキルや知識はできることなら増やさなくてもいいと感じている',	score:null, reverse:true	},
      {	id: 26, title:'新しい変化を求めるよりも、心がリラックスすることが大切だ',	score:null, reverse:true	},
      {	id: 27, title:'常に新しい業界や分野に飛び込んで学び続けたいと感じる',	score:null, reverse:false	},
      {	id: 28, title:'自分の好奇心から無駄遣いをしてしまうことがよくある',	score:null, reverse:false	},
      {	id: 29, title:'現状維持で居られるなら、それが一番ベストだと思う',	score:null, reverse:true	},
      {	id: 30, title:'普段の仕事に直結しない知識やスキルを学んでしまいがちである',	score:null, reverse:false	},  
    ],
    //【質問票04】コミュニケーション診断
    communicateQuestions:[
      {	id: 31, title:'どんな人との会話も無難にこなすことができる',	score:null , reverse:false },
      {	id: 32, title:'自分にとって会話は人生を豊かにする大きな武器だと感じている',	score:null, reverse:false	},
      {	id: 33, title:'本当に良い商品やサービスなら、交渉や営業はまったく苦にしない',	score:null, reverse:false	},
      {	id: 34, title:'一般的に自分はコミュ力が高い部類に入ると思う',	score:null, reverse:false	},
      {	id: 35, title:'知らない人とでも会話をするのが大好きだ',	score:null, reverse:true	},
      {	id: 36, title:'プライベートで相談役をよく頼まれたり、仕事で同僚や部下の悩みをよく話している',	score:null, reverse:false	},
      {	id: 37, title:'会社などの特定のコミュニティ以外の人たちとを積極的に会うようにしている',	score:null, reverse:false	},
      {	id: 38, title:'相手を気遣う心はあるが、なかなか行動までには踏み込めないと感じる',	score:null, reverse:true	},
      {	id: 39, title:'相手をエスコートすることにストレスを感じず、むしろ楽しいとさえ思う',	score:null, reverse:false	},
      {	id: 40, title:'仕事や恋愛を通して、人からよくモテてきたと感じている',	score:null, reverse:false	},  
    ],
    //【質問票05】アウトプット診断
    outputQuestions:[
      {	id: 41, title:'自分自身のアイデアを積極的に発表し、対価や評価を受ける機会がある',	score:null , reverse:false	},
      {	id: 42, title:'考えることは好きだが、考えたことを言葉にすることは苦手だ',	score:null, reverse:true	},
      {	id: 43, title:'書籍で学ぶよりも、動画で学ぶほうが自分には合っている',	score:null, reverse:true	},
      {	id: 44, title:'定期的に新しい知識や技術を使って、アウトプット作業をしている',	score:null, reverse:false	},
      {	id: 45, title:'専門職や技術職というよりは、一般職のキャリアを歩んでいるほうだと思う',	score:null, reverse:true	},
      {	id: 46, title:'企画書作りや戦略を練ったりするのは苦手なほうだ',	score:null, reverse:true	},
      {	id: 47, title:'1つものを掘り下げて発表するよりも、SNSなどの手軽なアウトプットを重ねるほうが好きだ',	score:null, reverse:true	},
      {	id: 48, title:'絵を描くこと、模型作り、インテリアデザインなど、特定の分野で自分の世界観を表現する趣味を持っている',	score:null, reverse:false	},
      {	id: 49, title:'突発的な意欲に駆られて、新しい料理や作品などの成果物を作ることがしばしばある',	score:null, reverse:false	},
      {	id: 50, title:'何かを創り上げることよりも、映画鑑賞や旅行などを楽しむほうが心が大きく晴れる',	score:null, reverse:true	},  
    ],
  },
  getters:{
    totalQuestion:function(state){
      let sum =0;
      sum = state.levelQuestions.length + state.sacrificeMindQuestions.length + state.investMindQuestions.lenth + state.communicateQuestions.length + state.outputQuestions.length
      return sum;
    },
    levelQuestionsScore: function (state) {
			let score = state.levelQuestions.map(item =>  Number(item.score))

			let sum = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sum = sum + score[i];
			}
			return sum;
		},
    //「スコア」と「％」の2つの値を戻す
    levelResult: function (state) {
			let score = state.levelQuestions.map(item =>  Number(item.score))

			let sumScore = 0;
      let percentage = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sumScore = sumScore + score[i];
			}
      percentage = Math.floor((sumScore)*50/36 +50)
      // 本番用
			return {sumScore:sumScore, percentage:percentage};
      // テスト用
      // return {sumScore:sumScore, percentage:Number(percentage*0+57)};
		},
    sacrificeMindResult: function (state) {
			let score = state.sacrificeMindQuestions.map(item =>  Number(item.score))

			let sumScore = 0;
      let percentage = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sumScore = sumScore + score[i];
			}
      percentage = Math.floor((sumScore)*5/3 +50)
      // 本番用
			return {sumScore:sumScore, percentageLeft:percentage,percentageRight:Number(100-percentage)};
      // テスト用
      // return {sumScore:sumScore, percentageLeft: Number(percentage*0+54),percentageRight:Number(percentage*0+46)};
		},    
		investMindResult: function (state) {
			let score = state.investMindQuestions.map(item =>  Number(item.score))

			let sumScore = 0;
      let percentage = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sumScore = sumScore + score[i];
			}
      percentage = Math.floor((sumScore)*5/3 +50)
      // 本番用
			return {sumScore:sumScore, percentageLeft:percentage,percentageRight:Number(100-percentage)};
      // テスト用
      // return {sumScore:sumScore, percentageLeft:Number(percentage*0+26),percentageRight:Number(percentage*0+74)};
		},
		communicateResult: function (state) {
			let score = state.communicateQuestions.map(item =>  Number(item.score))

			let sumScore = 0;
      let percentage = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sumScore = sumScore + score[i];
			}
      percentage = Math.floor((sumScore)*5/3 +50)
      // 本番用
			return {sumScore:sumScore, percentageLeft:percentage,percentageRight:Number(100-percentage)};
      // テスト用
      // return {sumScore:sumScore, percentageLeft:Number(percentage*0+72),percentageRight:Number(percentage*0+28)};
		},
		outputResult: function (state) {
			let score = state.outputQuestions.map(item =>  Number(item.score))

			let sumScore = 0;
      let percentage = 0;
			let i=0;
			for(i=0;i<score.length;++i)
			{
				sumScore = sumScore + score[i];
			}
      percentage = Math.floor((sumScore)*5/3 +50)
      // 本番用
			return {sumScore:sumScore, percentageLeft:percentage,percentageRight:Number(100-percentage)};
      // テスト用
      // return {sumScore:sumScore, percentageLeft:Number(percentage*0+28),percentageRight:Number(percentage*0+72)};
		},						
    solvedLevel:state => state.levelQuestions.filter(item => item.score !== null),
		solvedSacrificeMind: state => state.sacrificeMindQuestions.filter(item => item.score !== null),
		solvedInvestMind :state => state.investMindQuestions.filter(item => item.score !== null),
		solvedCommunicate: state => state.communicateQuestions.filter(item => item.score !== null),
		solvedOutput: state => state.outputQuestions.filter(item => item.score !== null),
    categoryMaxScore: state => state.sectionQuestion * state.plusMaxValue,
  },
});
